import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const fileUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);

const TOKEN_KEY = "op_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const COUNTRY_KEY = "op_country";
export const getCountry = () => localStorage.getItem(COUNTRY_KEY) || "EC";
export const setCountry = (c) => localStorage.setItem(COUNTRY_KEY, c);

export const COUNTRY_LABEL = { EC: "Ecu.", AR: "Arg." };
export const COUNTRY_NAME = { EC: "Ecuador", AR: "Argentina", PE: "Perú", CO: "Colombia", UY: "Uruguay", CL: "Chile", PY: "Paraguay" };
export const HOME_COUNTRIES = ["AR", "EC", "PE", "CO", "UY", "CL", "PY"];
export const COMING_SOON = ["PE", "CO", "UY", "CL", "PY"];
export const regLabel = (country) => (country === "AR" ? "Matrícula" : "Registro Senecyt");

export const trackWaClick = (id) => api.post(`/professionals/${id}/wa-click`).catch(() => {});

const DAY_LABELS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
export function getOpenStatus(schedule) {
  if (!schedule || schedule.length === 0) return null;
  const now = new Date();
  const today = DAY_LABELS[now.getDay()];
  const entry = schedule.find((s) => s.day === today);
  if (!entry || !entry.from || !entry.to) return { open: false, today };
  const cur = now.getHours() * 60 + now.getMinutes();
  const [fh, fm] = entry.from.split(":").map(Number);
  const [th, tm] = entry.to.split(":").map(Number);
  const open = cur >= fh * 60 + fm && cur <= th * 60 + tm;
  return { open, today, from: entry.from, to: entry.to };
}
